import React from "react"
import { RegistroInformeMensual } from "./RegistroInformeMensual";
import { HorasTotalesRegistroYHorarioInformeMensual } from "./HorasTotalesRegistroYHorarioInformeMensual";

export function InformeMensualExcel({ registrosMensuales }) {

  if (registrosMensuales !== null) {
    // console.log(registrosMensuales[1]);
    return (
      <table id="informeMensualTable" style={{display: "none"}}>
        <thead>
          <tr>
            <th style={{textAlign: "left"}}>Trabajador</th>
            <th style={{textAlign: "left"}}>Horas Totales</th>
            {registrosMensuales[0].registroMensual.map((diaMes) => (
              <th key={diaMes.fechaDia}>{diaMes.fechaDia}</th>
          ))}
          </tr>
        </thead>
        <tbody>
          {registrosMensuales.map((user) => (
            <tr key={user.uid}>
              <td style={{textAlign: "left"}}>{user.name} {user.apellidos}</td>
              <HorasTotalesRegistroYHorarioInformeMensual user={user} />
              {user.registroMensual.map((registroDia) => (
                <RegistroInformeMensual key={registroDia.fechaDia} registroDia={registroDia} /> 
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    )
  } else return(<></>);
}
